export default {
  supportFormLoadingState(state) {
    return state.loading;
  },
  supportFormLoadingProgressState(state) {
    return state.loadingProgress;
  },
};
